/**
 * File: apps/qbench-cp/reactapp/src/shared/theme/storage.js
 *
 * Purpose: Provides thin wrappers around the browser localStorage API for JSON-serializable
 *     values.
 *
 * Scope: Customer portal localStorage persistence, primarily used for caching the resolved
 *     theme object.
 *
 * Tags: customer-portal
 *
 * Overview: Exposes a setter that JSON-stringifies a value before writing it to localStorage
 *     under a given key, and a getter that reads a key back and JSON-parses it if present.
 *     Both functions are small pass-throughs with no validation or error handling beyond
 *     what JSON.parse/stringify provide natively.
 *
 * Exports: setLocalStorage, getLocalStorage
 */

export const setLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorage = (key) => {
  const value = localStorage.getItem(key);
  if (value) return JSON.parse(value);
};
